module.exports = __webpack_public_path__ + "static/media/screenshot.c3fd3120.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/devices/GutmannShowcaseBrowser/screenshot.jpg
// module id = 206
// module chunks = 0